import { PerformanceOptimization } from "@/components/PerformanceOptimization";

const PerformancePage = () => {
  return <PerformanceOptimization />;
};

export default PerformancePage;